// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2sk9t","detailsBorder":"styles_detailsBorder__3UzPS"};